export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10008.d15a4dbb.jpg";